const myDiv = document.getElementById('myDiv');
const targetElement = document.getElementById('targetElement');
let lastScroll = window.pageYOffset;
let timeout;

window.addEventListener('scroll', () => {
const currentScroll = window.pageYOffset;

// check if target element has been scrolled past
const targetRect = targetElement.getBoundingClientRect();
if (targetRect.bottom <= 0) {
  myDiv.style.display = 'block'; // show sticky bar
  if (currentScroll > lastScroll) { // scrolling down
    myDiv.style.bottom = '-1px';
  } else { // scrolling up
    myDiv.style.bottom = '-175px';
  }

  lastScroll = currentScroll;

  clearTimeout(timeout); // clear previous timeout (if any)
  timeout = setTimeout(() => {
    myDiv.style.bottom = '-175px'; // hide element after 500ms of inactivity
  }, 10000);
} else {
  myDiv.style.display = 'none'; // hide sticky bar
}
});